import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { DeleteOutlined, EditFilled, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row, Space, Switch } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { Banners, BannersType, CommonBody, Reviews } from "../../types/General";
import moment from "moment";
import ReplyToPostModal from "../../components/replyToPostModal/ReplyToPostModal";
import { useDeleteReviewMutation } from "../../services/support";
import { errorToast, successToast } from "../../helpers";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  useDeleteBannerMutation,
  useUpdateBannerStatusMutation,
} from "../../services/banner";
import { generateEncryptedKeyBody } from "../../utils/crypto";

const { confirm } = Modal;

// type PropTypes = {
//   scrollPosition?: ScrollPosition;
// };
interface DataType {
  key: string;
  title: string;
  description: string;
  customerName: string;
  date: string;
  email: string;
}

type Permission = {
  isAdd: boolean;
  isDelete: boolean;
};

type PropsConst = {
  activeTab: string;
  hidePermission: Permission;
  allBanners: Banners[] | [];
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalCount: number | undefined;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  query: string;
  setQuery: Dispatch<SetStateAction<string>>;
  getAllBannersData: (page: number) => void;
};

const EventBanner = ({
  activeTab,
  hidePermission,
  allBanners,
  setCurrentPage,
  setLoading,
  totalCount,
  setQuery,
  query,
  getAllBannersData,
  currentPage,
  loading,
}: PropsConst) => {
  const navigate = useNavigate();
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [deleteBanner] = useDeleteBannerMutation();

  console.log(allBanners, "allBannersallBanners");

  const [updateBannerStatus] = useUpdateBannerStatusMutation();

  const handleBannerStatus = async (isBlocked: boolean, _id: string) => {
    const data = {
      isBlocked: !isBlocked,
    };

    try {
      let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;

      const res = await updateBannerStatus({
        body: encryptedBody,
        bannerId: _id,
        activeTab: 2,
      }).unwrap();
      if (res?.statusCode === 200) {
        successToast(
          !isBlocked
            ? "Banner disabled successfully"
            : "Banner enabled successfully"
        );
        getAllBannersData(1);
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error?.data?.message);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "Banner Image",
      dataIndex: "image",
      key: "image",
      align: "center",
      render: (_, record) => (
        <div>
          {record?.image ? (
            <img
              alt="img"
              style={{ width: 40, height: 40, borderRadius: 5 }}
              src={record?.image}
            />
          ) : (
            "N/A"
          )}
        </div>
      ),
    },
    {
      title: "Title",
      key: "title",
      dataIndex: "title",
      align: "center",
    },
    {
      title: "Account Status",
      dataIndex: "isBlocked",
      key: "isBlocked",
      align: "center",
      render: (_, record) => (
        <div>
          <Switch
            size="small"
            checked={!record?.isBlocked}
            onChange={() => handleBannerStatus(record?.isBlocked, record?._id)}
          />
        </div>
      ),
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={(e) => {
              e.preventDefault();
              navigate(`/manage-banners/${record?._id}/${activeTab}`);
            }}
          >
            <EditFilled style={{ color: "#C69320" }} />
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              showDeleteConfirm(record);
            }}
          >
            <DeleteOutlined style={{ color: "#d4380d" }} />
          </Button>
        </Space>
      ),
    },
  ];

  const showDeleteConfirm = (record: any) => {
    confirm({
      title: "Hold on",
      content: "Are you sure you want to delete this banner?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(record?._id);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = async (id: string) => {
    try {
      const res = await deleteBanner({ bannerId: id, activeTab: 2 }).unwrap();
      if (res?.statusCode === 200) {
        successToast("Banner deleted successfully");
        getAllBannersData(currentPage);
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error?.data?.message);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getAllBannersData(page);
  };

  const pagination = {
    pageSize: 10,
    current: currentPage,
    total: totalCount,
    onChange: handlePageChange,
  };

  useEffect(() => {
    const delay = 1000; // Debounce delay in milliseconds
    const timerId = setTimeout(() => {
      setQuery(debouncedQuery);
    }, delay);

    return () => {
      clearTimeout(timerId); // Clear the timeout on cleanup
    };
  }, [debouncedQuery]);

  return (
    <div>
      <Row
        gutter={16}
        style={{
          paddingTop: 5,
          paddingBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col xs={24} md={7}>
          <Form
            style={{ display: "flex", gap: 20 }}
            onFinish={() => getAllBannersData(1)}
          >
            <Input
              placeholder="Search"
              prefix={<SearchOutlined style={{ fontSize: "24px" }} />}
              style={{ height: 50, borderRadius: 10 }}
              value={debouncedQuery}
              onChange={(e) => setDebouncedQuery(e.target.value)}
              maxLength={20}
            />
          </Form>
        </Col>
        <Button
          style={{
            background: "#ECAC35",
            minWidth: 100,
            height: 35,
            color: "black",
            fontWeight: 500,
          }}
          type="primary"
          onClick={() => navigate(`/manage-banners/add/${activeTab}`)}
        >
          Add Banner
        </Button>
      </Row>
      <Row gutter={16}>
        <Col xs={16} md={24}>
          <Table
            columns={columns}
            dataSource={allBanners}
            rowKey="_id"
            pagination={pagination}
            loading={loading}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EventBanner;
